import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["baseInputGroup", "inputList"];

  connect() {
    this.form = this.element.querySelector("form");
    this.submitButton = this.form.querySelector("input[type='submit']");

    this.handleInputChange = () => {
      const emails = Array.from(this.form.querySelectorAll("input[type='email']")).filter(
        (input) => input.value.trim() !== ""
      );
      const emailsCount = emails.length;
      const submitButtonValue =
        emailsCount > 0
          ? `Send ${emailsCount} ${emailsCount === 1 ? "invite" : "invites"}`
          : "Send invites";
      this.submitButton.disabled = emailsCount < 1;
      this.submitButton.value = submitButtonValue;
    };

    this.form.addEventListener("input", this.handleInputChange);
  }

  disconnect() {
    this.form.removeEventListener("input", this.handleInputChange);
  }

  addInputGroup() {
    const inputGroup = this.baseInputGroupTarget.cloneNode(true);
    inputGroup.querySelector("input[type='email']").value = "";
    this.inputListTarget.appendChild(inputGroup);
  }
}
